import dynamic from 'next/dynamic';

const PresetLabDynamic = dynamic(() => import('./PresetLab'), { ssr: false });

export default PresetLabDynamic;